import React from "react";
import { useNavigate } from "react-router-dom";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import FilterableList from "components/ListOption/FilterableList";

import { useAppMeta } from "hooks";

import { ACCOUNT_LIST_OPTIONS } from "data/static/accountListOptions";

const AccountListOptionScreen = () => {
  const breadcrumbs = [{ title: "Account List" }];

  const navigate = useNavigate();

  useAppMeta("Account List");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs}>
      <BreadcrumbLayout.Paper>
        <FilterableList
          title="Account List"
          list={ACCOUNT_LIST_OPTIONS}
          onItemClick={() => navigate()}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default AccountListOptionScreen;
